import React from 'react';
import styled from '@emotion/styled';
import { Box, Link } from '@mui/material';
import Typography from '@mui/material/Typography';

const FooterContainer = styled('footer')(({ theme }) => ({
  padding: theme.spacing(2),
  textAlign: 'center',
}));

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <FooterContainer>
      <Box sx={{ m: 2 }}>
        <Typography
          variant='body2'
          align='center'
          sx={{
            fontFamily: 'Neue Montreal Medium',
          }}
        >
          Inspired from{' '}
          <Link href='https://www.richardekwonye.com/' target='_blank'>
            Richard Ekwonye
          </Link>
        </Typography>
        <Typography
          variant='body2'
          align='center'
          sx={{
            fontFamily: 'Neue Montreal Medium',
          }}
        >
          &copy; {currentYear} ASHVIN C K. All rights reserved.
        </Typography>
      </Box>
    </FooterContainer>
  );
};

export default Footer;
